import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/services/api'

interface UpdateEpisodeProgressData {
  completed?: boolean
  watchedDuration?: number
}

export function useUpdateEpisodeProgress() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      episodeId,
      data,
    }: {
      episodeId: number
      data: UpdateEpisodeProgressData
    }) => {
      const response = await api.post(`/episodes/${episodeId}/progress`, data)
      return response.data
    },
    onSuccess: () => {
      // Invalida queries relacionadas ao progresso do usuário
      queryClient.invalidateQueries({ queryKey: ['user-progress'] })
      queryClient.invalidateQueries({ queryKey: ['episode'] })
    },
  })
}
